import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import Table from "components/Table";
import ClientsFilters from "../ClientsFilters";

import website_status_data from "libs/website_status_data.json";

const ClientsTable = ({ data, loading, filters, filterHandler }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();

  const tableData = {
    keys: [
      { sort_key: "website", key: "website-full", value: t("Website [SHORT]") },
      { key: "tasks", value: t("Tasks") },
      { key: "status", value: t("Status") },
      { sort_key: "subscription", key: "subscription_plan", value: t("Subscription plan") },
      { key: "details", sort_key: false, value: t("Details") },
    ],
    items: data?.map(({ _id, website, tasks, status, subscription }) => {
      const statusData = website_status_data.find((item) => item.value === status);

      return [
        {
          key: "website-full",
          type: "link",
          value: { label: website, href: `/clients/${_id}${search}` },
        },
        { key: "tasks", value: tasks },
        {
          key: "status",
          type: "pill",
          value: {
            data: { label: t(statusData?.label), color: statusData?.color },
            isCompletelyDisabled: true,
          },
        },
        { key: "subscription_plan", value: subscription?.[0]?.name },
        {
          key: "details",
          type: "clickable_text",
          value: {
            label: t("View"),
            onclick: () => navigate(`/clients/${_id}${search}`),
          },
        },
      ];
    }),
  };

  return (
    <Table
      data={tableData}
      loading={loading}
      sort={filters?.sort}
      setSort={(value) => filterHandler("sort", value)}
      filters_new={
        <div className="clients-admin-table__filters">
          <ClientsFilters
            t={t}
            values={filters}
            onChange={(name, value) => filterHandler(name, value, true)}
          />
        </div>
      }
    />
  );
};

export default ClientsTable;